import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { DialogProvider } from '@sara/ui/components/dialog-provider';
import { Toaster } from '@sara/ui/components/sonner';
import type { RouterContext } from './types';

const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <DialogProvider>
      <Outlet />
      <Toaster position="bottom-right" richColors closeButton />
    </DialogProvider>
  ),
});

export { rootRoute };
